import { createBrowserRouter } from 'react-router-dom'
import Layout from '@/components/layout/Layout'
import { RouteErrorBoundary } from '@/components/routing/RouteErrorBoundary'
import { adminRoutes } from '@/routes/adminRoutes'
import { privateRoutes } from '@/routes/privateRoutes'
import { publicRoutes } from '@/routes/publicRoutes'
import { sharedRoutes } from '@/routes/sharedRoutes'

export const router = createBrowserRouter([
  ...publicRoutes,
  {
    path: '/',
    element: <Layout />,
    errorElement: <RouteErrorBoundary />,
    children: [privateRoutes, adminRoutes, ...sharedRoutes],
  },
])
